export enum ItemFeatureHighlightDecoration {
  BubbleN0 = 'Bubble (N0)',
}
